// frontend/src/data/whatsNewIcons.js
// CODEX_PROMPT_88 : catalogue d'icones autorisees pour les cartes "Quoi de neuf".
// UNIQUE source de verite cote frontend. La meme liste de cles est validee cote
// SQL dans la RPC upsert_whats_new_card et la contrainte CHECK de la table.
//
// Teintes douces reprises du design system (peach / sage / lavender / sky).
// Pas d'emoji libre, pas d'icone arbitraire : l'admin choisit une cle ci-dessous.
import {
  Sparkles,
  Eye,
  Lamp,
  Camera,
  Brush,
  Gift,
  Palette,
  Target,
  Star,
  BookOpen,
  Wand2,
  Music,
} from 'lucide-react';

export const WHATS_NEW_ICONS = {
  sparkles: { icon: Sparkles, iconBg: 'rgba(232, 185, 110, 0.22)', iconColor: '#C68E3E' },
  eye:      { icon: Eye,      iconBg: 'rgba(168, 200, 184, 0.22)', iconColor: '#7A9D85' },
  lamp:     { icon: Lamp,     iconBg: 'rgba(232, 185, 110, 0.22)', iconColor: '#C68E3E' },
  camera:   { icon: Camera,   iconBg: 'rgba(232, 132, 92, 0.15)',  iconColor: 'var(--color-primary)' },
  brush:    { icon: Brush,    iconBg: 'rgba(168, 200, 184, 0.22)', iconColor: '#7A9D85' },
  gift:     { icon: Gift,     iconBg: 'rgba(232, 132, 92, 0.15)',  iconColor: 'var(--color-primary)' },
  palette:  { icon: Palette,  iconBg: 'rgba(196, 181, 220, 0.22)', iconColor: '#8E7BB0' },
  target:   { icon: Target,   iconBg: 'rgba(232, 132, 92, 0.15)',  iconColor: 'var(--color-primary)' },
  star:     { icon: Star,     iconBg: 'rgba(232, 185, 110, 0.22)', iconColor: '#C68E3E' },
  book:     { icon: BookOpen, iconBg: 'rgba(168, 200, 184, 0.22)', iconColor: '#7A9D85' },
  wand:     { icon: Wand2,    iconBg: 'rgba(196, 181, 220, 0.22)', iconColor: '#8E7BB0' },
  music:    { icon: Music,    iconBg: 'rgba(168, 195, 214, 0.22)', iconColor: '#6E92AD' },
};

// Cle par defaut / de repli pour toute icon_key inconnue.
export const WHATS_NEW_DEFAULT_ICON_KEY = 'sparkles';

// Liste ordonnee des cles, pour la grille de selection de l'admin.
export const WHATS_NEW_ICON_KEYS = Object.keys(WHATS_NEW_ICONS);

/**
 * Resout une icon_key vers son entree { icon, iconBg, iconColor }.
 * Repli sur 'sparkles' si la cle est absente ou inconnue.
 * @param {string} iconKey
 * @returns {{ icon: Function, iconBg: string, iconColor: string }}
 */
export function resolveWhatsNewIcon(iconKey) {
  return WHATS_NEW_ICONS[iconKey] || WHATS_NEW_ICONS[WHATS_NEW_DEFAULT_ICON_KEY];
}
